import React, { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { Button } from 'react-bootstrap'

import Header from 'components/ui/header'
import CircleFinish from 'components/ui/finish_circle'
import SquareWinner from 'components/ui/square_winner'

import Colors from 'utils/colors'

import '../../assets/style/final_views.css'

const WinnerView = ({ onProceedToReward }) => {
  const navigate = useNavigate()
  const location = useLocation()
  const { id } = location.state || {}

  useEffect(()=>{
    console.log(id);
  },[])  

  // const result = async () => {
  //   const body = {
  //     idActivity: id,
  //     status: '1',
  //     user: 'Yelmo',
  //   }
  //   const response = await postResult(body)
  // }

  return (
    <div className="finish-container" style={styles.container}>
      <Header />
      <div className="circle-container-winner">
        <CircleFinish
          size={'581px'}
          gradient={`linear-gradient(18.38deg, ${Colors.primary} -22.98%, ${Colors.yelmoGreen} 97.02%)`}
        />
      </div>
      <div style={styles.containerText}>
        <h1 className="responsive-text-winner" style={styles.congrats}>
          ¡Lo lograste!
        </h1>
      </div>
      <div style={styles.containerText}>
        <h1 style={styles.receive}>Recibiste:</h1>
      </div>
      <SquareWinner points={50} label="Yelmo points" />
      <Button
        style={styles.button}
        className="mb-3"
        onClick={() => {
          onProceedToReward()
          navigate('/reward', { state: { id: id, exchage:true } })
        }}
      >
        <span style={styles.letter}>¡Canjear mi premio!</span>
      </Button>
    </div>
  )
}

const styles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    background: `linear-gradient(170.52deg, ${Colors.primary} 14.08%, ${Colors.yelmoGreen} 91.16%)`,
  },
  containerText: {
    marginBottom: '5%',
  },
  congrats: {
    color: Colors.white,
    fontFamily: 'TTNormsRegular',
    fontWeight: 'bold',
    display: 'flex',
    justifyContent: 'flex-start',
  },
  receive: {
    color: Colors.white,
    fontFamily: 'TTNormsRegular',
    fontWeight: 'bold',
    fontSize: 'xx-large',
    display: 'flex',
    justifyContent: 'flex-start',
  },
  button: {
    backgroundColor: Colors.white,
    borderColor: Colors.white,
    height: '60px',
    color: Colors.secondary,
    fontFamily: 'TTNormsRegular',
    fontSize: 'large',
    fontWeight: 'bold',
    width: '50%',
    marginLeft: '2%',
    borderRadius: '10px',
  },
}

export default WinnerView
